
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 10);
    };
    
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-slate-900/90 backdrop-blur-md py-3 shadow-sm"
          : "bg-transparent py-5"
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img 
                src="/lovable-uploads/fa909f5b-d62e-45ec-a325-8c5f97703d9f.png" 
                alt="Bizlytics Logo" 
                className="h-8 w-auto mr-2" 
              />
              <div className="font-bold text-xl">
                <span className="text-yellow-500">Bizlytics</span>.io
              </div>
            </Link>
          </div>

          {/* Desktop navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link
              to="/#features"
              className="text-sm font-medium text-gray-200 hover:text-primary transition-colors"
            >
              Features
            </Link>
            <Link
              to="/#integrations"
              className="text-sm font-medium text-gray-200 hover:text-primary transition-colors"
            >
              Integrations
            </Link>
            <Link
              to="/#templates"
              className="text-sm font-medium text-gray-200 hover:text-primary transition-colors"
            >
              Templates
            </Link>
            <Link
              to="/#pricing"
              className="text-sm font-medium text-gray-200 hover:text-primary transition-colors"
            >
              Pricing
            </Link>
          </nav>

          <div className="hidden md:flex items-center space-x-2">
            {/* Removed ThemeToggle */}
            <Link to="/login">
              <Button variant="outline" className="font-medium">
                Log In
              </Button>
            </Link>
            <Link to="/signup">
              <Button className="font-medium button-shine">
                Sign Up Free
              </Button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="flex md:hidden items-center space-x-2">
            {/* Removed ThemeToggle */}
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setIsOpen(!isOpen)}
              aria-label="Toggle menu"
            >
              {isOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </Button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${
          isOpen
            ? "max-h-[400px] opacity-100 border-b border-gray-800"
            : "max-h-0 opacity-0"
        }`}
      >
        <div className="container mx-auto px-4 py-4 space-y-4 bg-slate-900/90 backdrop-blur-sm">
          <Link
            to="/#features"
            className="block py-2 text-base font-medium text-gray-200 hover:text-primary"
            onClick={() => setIsOpen(false)}
          >
            Features
          </Link>
          <Link
            to="/#integrations"
            className="block py-2 text-base font-medium text-gray-200 hover:text-primary"
            onClick={() => setIsOpen(false)}
          >
            Integrations
          </Link>
          <Link
            to="/#templates"
            className="block py-2 text-base font-medium text-gray-200 hover:text-primary"
            onClick={() => setIsOpen(false)}
          >
            Templates
          </Link>
          <Link
            to="/#pricing"
            className="block py-2 text-base font-medium text-gray-200 hover:text-primary"
            onClick={() => setIsOpen(false)}
          >
            Pricing
          </Link>
          <div className="pt-4 flex flex-col space-y-2">
            <Link to="/login" onClick={() => setIsOpen(false)}>
              <Button variant="outline" className="w-full font-medium">
                Log In
              </Button>
            </Link>
            <Link to="/signup" onClick={() => setIsOpen(false)}>
              <Button className="w-full font-medium">Sign Up Free</Button>
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}
